import { ReactNode, ReactPortal, SyntheticEvent, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { uniqueId } from 'lodash';

import { Overlay, Sheet } from '@r1-frontend/ui-react/components/Modal';
import { createRootElement } from '@r1-frontend/shared/helpers/dom';

import * as S from './styled';

export type BottomSheetProps = {
    children: ReactNode,
    onClose: () => void,
    isShown: boolean,
    id?: string,
}

const BottomSheet = ({
    children,
    onClose = () => true,

    isShown = false,
    id,

    ...props
}: BottomSheetProps): ReactPortal | null => {
    const [popupRoot, setPopupRoot] = useState<HTMLElement | null>(null);

    useEffect(() => {
        const root = createRootElement(`bottom-sheet-${id ? id : uniqueId()}`);
        setPopupRoot(root);

        return () => {
            popupRoot && popupRoot.remove();
        };
    }, []);

    const onCloseHandler = (e: SyntheticEvent) => {
        e.stopPropagation();
        onClose();
    };

    return popupRoot
        ? createPortal(
            <div {...props} aria-hidden={!isShown}>
                {isShown && <Overlay onClick={onCloseHandler}/>}
                <S.Content>
                    <Sheet onIconClick={onCloseHandler}>
                        {children}
                    </Sheet>
                </S.Content>
            </div>,
            popupRoot,
        )
        : null;
};

export default BottomSheet;
